import { FC } from 'react';

import { AccountCircle } from '@mui/icons-material';
import {
  useTheme,
  Avatar,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { get } from 'lodash';

import { abbreviateId, abbreviateNumber, formatDateTime, isAddressFromPegaxyTeam } from '../../../utils/humanizer';
import { PgxIcon } from '../../layout/icons/pgx-icon';
import { TooltipCopy } from '../TooltipCopy';
import CommentHighlighter from './CommentHighlighter';
import { ThreadedCommentShape } from './interface';

export const ThreadedComment: FC<ThreadedCommentShape> = ({
  date,
  userTag,
  publicAddress,
  pgx,
  text,
  isReplyBoxOpen,
}) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        ml: 4,
        borderLeft: isReplyBoxOpen ? 2 : 1,
        borderColor: isReplyBoxOpen ? get(theme, 'palette.primary.main', 'primary') : 'divider',
        p: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <AccountCircle sx={{ mr: 2, height: 48, width: 48 }} />
      <Box sx={{ width: 'calc(100% - 64px)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ width: '100%', minWidth: 0, pr: 3 }}>
            <TooltipCopy
              value={userTag || publicAddress}
              hiddeTooltip={isAddressFromPegaxyTeam(userTag || publicAddress)}
              placement="top-start"
            >
              <Typography
                variant="body1"
                sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
              >
                {userTag || abbreviateId(publicAddress)}
              </Typography>
            </TooltipCopy>
          </Box>
          <Box sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="body2" color="text.secondary">
              {formatDateTime(date)}
            </Typography>
          </Box>
        </Box>
  
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
          {userTag && (
            <>
              <Avatar
                sx={{ height: 16, width: 16, mr: 1 }}
                src="https://pegaxy.io/wp-content/uploads/2021/09/cropped-logo-seo.jpg"
              />
              <Typography variant="body2" color="text.secondary">
                Pegaxy Team
              </Typography>
            </>
          )}
          {pgx && (
            <>
              <PgxIcon sx={{ height: 16, width: 16, mr: 1 }} />
              <Typography variant="body2" color="text.secondary">
                {abbreviateNumber(pgx)}
              </Typography>
            </>
          )}
        </Box>
  
      </Box>
      </Box>
      {text && text.split(/\r\n|\r|\n/g).map((line: string) => {
        if (line) {
          return <CommentHighlighter line={line} />;
        }
        return <br />;
      })}
    </Stack>
  );
};
